import {api} from '@/api/factory';

class Voiceovers {
    constructor() {}

    get() {
        return api.get('/v1/content-manager/voiceovers', {
            params: {
                page: 1,
                per_page: 10000
            }
        })
    }
}

export default Voiceovers